/**
 * @generated SignedSource<<9a9f84f0ac9688d9f4d05748eca518aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type StudentSkillAssessmentWeeklySnapshotFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  gradeLevelIds?: ReadonlyArray<string> | null | undefined;
  isActive?: boolean | null | undefined;
  reportFromDate: any;
  reportToDate: any;
  siteIds?: ReadonlyArray<string> | null | undefined;
  targetGroupIds?: ReadonlyArray<string> | null | undefined;
};
export type DashboardGetWeeklySnapshotQuery$variables = {
  filter: StudentSkillAssessmentWeeklySnapshotFilterInput;
};
export type DashboardGetWeeklySnapshotQuery$data = {
  readonly studentsSkillAssessmentsWeeklySnapshot: ReadonlyArray<{
    readonly numberOfStudents: number;
    readonly uniqueSkillsPassed: number | null | undefined;
  }>;
};
export type DashboardGetWeeklySnapshotQuery = {
  response: DashboardGetWeeklySnapshotQuery$data;
  variables: DashboardGetWeeklySnapshotQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      }
    ],
    "concreteType": "StudentsSkillAssessmentsWeeklySnapshotReport",
    "kind": "LinkedField",
    "name": "studentsSkillAssessmentsWeeklySnapshot",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uniqueSkillsPassed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "numberOfStudents",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardGetWeeklySnapshotQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardGetWeeklySnapshotQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f11a100ffaeaf9b79d2cff78df0f2957",
    "id": null,
    "metadata": {},
    "name": "DashboardGetWeeklySnapshotQuery",
    "operationKind": "query",
    "text": "query DashboardGetWeeklySnapshotQuery(\n  $filter: StudentSkillAssessmentWeeklySnapshotFilterInput!\n) {\n  studentsSkillAssessmentsWeeklySnapshot(filter: $filter) {\n    uniqueSkillsPassed\n    numberOfStudents\n  }\n}\n"
  }
};
})();

(node as any).hash = "f0a6a8447c12ce927e889e2ea7d13c30";

export default node;
